import { render } from "./MerchantPurchase.vue?vue&type=template&id=7daa35d4&scoped=true"
import script from "./MerchantPurchase.vue?vue&type=script&lang=js"
export * from "./MerchantPurchase.vue?vue&type=script&lang=js"

import "./MerchantPurchase.vue?vue&type=style&index=0&id=7daa35d4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7daa35d4"]])

export default __exports__